import { standardDate } from '@/helpers/DateFormatter';
export class RecipientOrderDetailsModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    get dateOfPurchase() {
        return standardDate(this.createdAt);
    }
}
